import React, { useState } from 'react';
import './App.css';
import { Routes, Route, useLocation } from 'react-router-dom';
import { Helmet } from 'react-helmet';

import NavBar from './components/Navbar';
import Banner from './components/Banner';
import Technology from './components/Technology';
import Services from './components/Services';
import ConnectForm from './components/ConnectForm';
import Footer from './components/Footer';
import AboutUs from './components/AboutUs';
import SocialIcons from './components/SocialMedia';
import WebDevelopment from './components/WebDevlopmentServices';
import ApplicationDevelopment from './components/ApplicationDevlopment';
import DigitalMarketing from './components/DigitalMarketing';
import Seo from './components/Seo';
import CloudServices from './components/CloudService';
import AIML from './components/AiMl';
import AdminLogin from './Admin/AdminLogin';
import UserContactDetails from './Admin/UserContactDetails';
import GreetPopUp from './components/GreetPopUp';
import ProjectDetails from './Admin/ProjectDetails';
import PricingSection from './components/PricingSection';

function App() {
  const [isFormVisible, setFormVisible] = useState(false);
  const location = useLocation();

  const handleConnectClick = () => {
    setFormVisible(true);
  };

  const handleCloseForm = () => {
    setFormVisible(false);
  };

  const shouldShowNavBar =
    location.pathname === '/' ||
    location.pathname === "/services" ||
    location.pathname === "/packages";
  return (
    <div className="App">
      <GreetPopUp />
      {shouldShowNavBar && <NavBar onConnectClick={handleConnectClick} />}
      <Routes>
        <Route
          path="/"
          element={
            <>
              <Helmet>
                <title>YTC Tech Ventures | Best IT Services & Digital Solutions</title>
                <meta
                  name="description"
                  content="YTC Tech Ventures offers top-notch IT solutions including web & app development, AI/ML, cloud computing, SEO, and digital marketing."
                />
                <link rel="canonical" href="https://ytctechventures.com/" />
              </Helmet>

              <ConnectForm isVisible={isFormVisible} onClose={handleCloseForm} />
              <Banner onConnectClick={handleConnectClick} />
              <Services onConnectClick={handleConnectClick} />
              <Technology />
              <div className="about-us-container">
                <AboutUs />
                <Footer className="footer" />
              </div>
            </>
          }
        />

        <Route
          path="/services"
          element={
            <>
              <Helmet>
                <title>YTC Tech Ventures | Best IT Services & Digital Solutions</title>
                <meta
                  name="description"
                  content="YTC Tech Ventures offers top-notch IT solutions including web & app development, AI/ML, cloud computing, SEO, and digital marketing."
                />
                <link rel="canonical" href="https://ytctechventures.com/services" />
              </Helmet>

              <ConnectForm isVisible={isFormVisible} onClose={handleCloseForm} />
              <Banner onConnectClick={handleConnectClick} />
              <Services onConnectClick={handleConnectClick} />
              <Technology />
              <div className="about-us-container">
                <AboutUs />
                <Footer className="footer" />
              </div>
            </>
          }
        />

        <Route
          path="/services/web-development"
          element={
            <>
              <Helmet>
                <title>Web Development Services | YTC Tech Ventures</title>
                <meta
                  name="description"
                  content="Get professional web development services at YTC Tech Ventures. We create fast, secure, and SEO-friendly websites tailored to your business needs."
                />
                <link rel="canonical" href="https://ytctechventures.com/services/web-development" />
              </Helmet>
              <WebDevelopment />
            </>
          }
        />

        <Route
          path="/services/application-development"
          element={
            <>
              <Helmet>
                <title>App Development Services | YTC Tech Ventures</title>
                <meta
                  name="description"
                  content="Build powerful mobile apps with our expert application development services. We specialize in Android, iOS, and cross-platform solutions."
                />
                <link rel="canonical" href="https://ytctechventures.com/services/application-development" />
              </Helmet>
              <ApplicationDevelopment onConnectClick={handleConnectClick} />
            </>
          }
        />

        <Route
          path="/services/digital-marketing"
          element={
            <>
              <Helmet>
                <title>Digital Marketing Services | YTC Tech Ventures</title>
                <meta
                  name="description"
                  content="Boost your online presence with YTC Tech Ventures' digital marketing services, including SEO, PPC, social media, and content marketing."
                />
                <link rel="canonical" href="https://ytctechventures.com/services/digital-marketing" />
              </Helmet>
              <DigitalMarketing />
            </>
          }
        />

        <Route
          path="/services/seo-services"
          element={
            <>
              <Helmet>
                <title>SEO Services | YTC Tech Ventures</title>
                <meta
                  name="description"
                  content="Improve your search rankings with YTC Tech Ventures' expert SEO services, including on-page, off-page, and technical SEO."
                />
                <link rel="canonical" href="https://ytctechventures.com/services/seo-services" />
              </Helmet>
              <Seo />
            </>
          }
        />

        <Route
          path="/services/cloud-services"
          element={
            <>
              <Helmet>
                <title>Cloud Solutions | YTC Tech Ventures</title>
                <meta
                  name="description"
                  content="Scale your business with our secure cloud services, including cloud migration, hosting, and maintenance solutions."
                />
                <link rel="canonical" href="https://ytctechventures.com/services/cloud-services" />
              </Helmet>
              <CloudServices />
            </>
          }
        />

        <Route
          path="/services/AI-ML-Services"
          element={
            <>
              <Helmet>
                <title>AI & ML Solutions | YTC Tech Ventures</title>
                <meta
                  name="description"
                  content="Leverage AI & ML to transform your business with intelligent automation, data analytics, and machine learning solutions."
                />
                <link rel="canonical" href="https://ytctechventures.com/services/AI-ML-Services" />
              </Helmet>
              <AIML />
            </>
          }
        />

        <Route
          path="/admin/login"
          element={
            <>
              <Helmet>
                <title>Admin Login | YTC Tech Ventures</title>
                <meta name="robots" content="noindex, nofollow" />
                <link rel="canonical" href="https://ytctechventures.com/admin/login" />
              </Helmet>
              <AdminLogin />
            </>
          }
        />

        <Route
          path="/Leadpage"
          element={
            <>
              <Helmet>
                <title>User Contact Details | YTC Tech Ventures</title>
                <meta name="robots" content="noindex, nofollow" />
                <link rel="canonical" href="https://ytctechventures.com/Leadpage" />
              </Helmet>
              <UserContactDetails />
            </>
          }
        />

        <Route
          path="/ProjectDetails"
          element={
            <>
              <Helmet>
                <title>Project Details | YTC Tech Ventures</title>
                <meta name="robots" content="noindex, nofollow" />
                <link rel="canonical" href="https://ytctechventures.com/ProjectDetails" />
              </Helmet>
              <ProjectDetails />
            </>
          }
        />

        <Route
          path="/packages"
          element={
            <>
              <Helmet>
                <title>
                  Website & Software Development Packages | YTC Tech Ventures
                </title>

                <meta
                  name="description"
                  content="Explore website development, ERP, CRM, mobile app development and enterprise software packages from YTC Tech Ventures."
                />

                <meta
                  name="keywords"
                  content="website packages, software development packages, mobile app development, ERP development, CRM development"
                />

                <link
                  rel="canonical"
                  href="https://ytctechventures.com/packages"
                />
              </Helmet>

              <PricingSection />

              <div className="about-us-container">
                <Footer className="footer" />
              </div>
            </>
          }
        />
      </Routes>
      <SocialIcons />
    </div>
  );
}

export default App;
